import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      isUpdating: false
    };
  }

  static getDerivedStateFromError(error) {
    // If it's a ChunkLoadError, flag it
    if (error && error.name === 'ChunkLoadError') {
      return { hasError: true, isUpdating: true };
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);

    if (error && error.name === 'ChunkLoadError') {
      // Show "Updating panel" UI briefly, then force cache-busting reload
      setTimeout(() => {
        window.location.href = window.location.pathname + "?v=" + Date.now();
      }, 500);
    }
  }

  render() {
    if (this.state.isUpdating) {
      return (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'var(--bg-primary, #0a0a0f)', zIndex: 99999,
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          color: 'var(--text-primary, #e8e8ed)', fontFamily: 'var(--font-sans)'
        }}>
          <h2 style={{ marginBottom: '1rem', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.25rem' }}>Updating panel...</h2>
          <p style={{ color: 'var(--text-secondary, #8b8b9e)', fontSize: '0.9rem' }}>Refreshing interface to load new features</p>
          <div style={{ marginTop: '20px', width: '36px', height: '36px', border: '2px solid var(--border-subtle, rgba(255,255,255,0.06))', borderTopColor: 'var(--accent-blue, #3b82f6)', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
          <style>{`
            @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
          `}</style>
        </div>
      );
    }

    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: 'var(--app-vh, 100vh)',
          background: 'var(--bg-primary, #0a0a0f)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'var(--font-sans)',
        }}>
          <div style={{
            background: 'var(--bg-card, #111118)',
            border: '1px solid var(--border-subtle, rgba(255,255,255,0.06))',
            borderRadius: 'var(--radius-lg, 12px)',
            padding: '2.5rem 3rem',
            textAlign: 'center',
            maxWidth: 400,
            width: '100%',
          }}>
            <div style={{
              width: 48, height: 48, borderRadius: '50%',
              background: 'rgba(239,68,68,0.08)',
              border: '1px solid rgba(239,68,68,0.15)',
              color: '#ef4444',
              fontSize: '1.3rem',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 1.25rem',
            }}>✕</div>
            <h2 style={{
              fontFamily: 'var(--font-display)',
              color: 'var(--text-primary, #e8e8ed)',
              fontSize: '1.1rem',
              fontWeight: 700,
              margin: '0 0 0.5rem',
            }}>Something went wrong</h2>
            <p style={{
              color: 'var(--text-secondary, #8b8b9e)',
              fontSize: '0.85rem',
              margin: '0 0 1.5rem',
              lineHeight: 1.5,
            }}>An unexpected error occurred. Please reload the page.</p>
            <button
              onClick={() => window.location.href = window.location.pathname + "?v=" + Date.now()}
              style={{
                padding: '10px 24px',
                background: 'var(--accent-blue, #3b82f6)',
                color: '#fff',
                border: 'none',
                borderRadius: 'var(--radius-md, 8px)',
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: '0.875rem',
                fontFamily: 'var(--font-sans)',
                transition: 'opacity 0.15s',
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
